import { Typography } from '@ag1/ui';

export const CustomSectionHeadline: React.FC<{
  className?: string;
  text: string;
  size?: '2' | '3';
}> = ({ className, text, size = '2' }) => (
  <Typography
    className={className}
    component={`h${size}`}
    variant="headlineSans"
    size={size}
    noPadding>
    {text}
  </Typography>
);
